import React from 'react';
import { PageContent, PageSection, Subtitle, Title } from 'common/styles/page';

const PrivacyPolicy = () => (
  <PageContent>
    <PageSection padright>
      <Title>nuLogic Privacy Policy</Title>

      <PageSection padbottom padtop="30px">
        <Subtitle>nuwave Privacy Statement</Subtitle>
        <p>
          nuwave (“nuwave”, “nuLogic”, “we”, “us” or “our”) takes steps intended to meet privacy
          principles and requirements with respect to personal information under applicable United
          States privacy legislation. The purpose of this statement is to inform our customers and
          other individuals we deal with (“you” or “your”) how we collect, use, disclose and protect
          your personal information. Personal information is information about an identifiable
          individual, as more particularly described under applicable privacy legislation. This
          statement applies to our collection, use and disclosure of personal information in the
          United States. This statement does not apply to information about our employees or to
          information that is not personal information.
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Data Controller and Data Processor</Subtitle>
        <p>
          nuwave’s business customers are the data controllers for most of the information that is
          entered into the nuLogic web application, website, and supporting systems or that is
          shared periodically with nuwave employees to deliver services. This positions nuwave as
          the data processor for most information stored and processed by nuLogic. There are some
          pieces of information that are collected directly by nuLogic to facilitate security,
          logging, and application performance. These items include IP address and behavior within
          the nuLogic platform. For these pieces of information nuLogic acts as the data controller
          and processor. Additionally, nuLogic employs a variety of technologies and partners that
          periodically act as sub-processors. If users have any questions or concerns about the
          processing and handling of their personal information, they may reach out to nuwave
          directly by email at info@nuwaveco.com.
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Personal Information We Collect</Subtitle>
        <p>
          nuwave and its agents and representatives collect personal information in a number of
          circumstances in the course of assisting organizations in their mandate to analyze,
          improve, and track culture in your organization. Personal information we collect includes:
        </p>
        <ul>
          <li>Details on role/position within your organization;</li>
          <li>
            Sentiment around personal experiences of safety, mental and physical health, leadership,
            work environment, professional development, and other areas in relation to the culture
            of your organization;
          </li>
          <li>
            Such other information we may collect with your consent or as permitted or required by
            law.
          </li>
        </ul>
        <p>
          All personal information above is collected with explicit consent in the form of an opt-in
          box prior to any disclosure of information. Consent is digitally recorded and logged,
          including IP address and date of consent. See the section on Consent for more information.
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Use of Personal Information</Subtitle>
        <p>nuwave generally uses personal information for the following purposes:</p>
        <ul>
          <li>Provide your organization or community with aggregated insights on culture;</li>
          <li>Track progress on culture within your organization or communiy;</li>
          <li>Create role-specific culture benchmaks;</li>
          <li>
            Publish aggregated findings and statistics o raise awareness on culture through
            traditional and social media;
          </li>
          <li>Manage, administer, collect, or otherwise enforce accouts;</li>
          <li>
            Maintain business records for reasonable periods and generallymanage and administer our
            business, including defending and bringing legal actions;
          </li>
          <li>Meet legal, regulatory, insurance, security, and processing requirements; </li>
          <li>Otherwise with consent or as permitted or required by aw.</li>
        </ul>
        <p>
          Results and insights are always shared in an aggregated and anonymized form and are never
          attributed to individuals. The minimum number of aggregated results is defined by your
          organization prior to data collection. The minimum number of aggregated results can never
          be less than 3.
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Mode, Place, and Methods of Processing the Data</Subtitle>
        <p>
          nuwave takes appropriate security measures to prevent unauthorized access, disclosure,
          modification, or data destruction
        </p>
        <p>
          Data is processed using computers or tech-enabled tools, following organizational policies
          and procedures strictly related to the purposes indicated. In some cases, data may be
          accessible to nuwave employees involved with the nuwave website’s operation, the nuLogic
          web application (platform), and supporting applications. Data may also be accessible to
          external parties appointed, if necessary, as data processors or sub-processors by nuwave.
          External parties may include third-party technical service providers, hosting providers,
          and IT companies.
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Legal Basis of Processing</Subtitle>
        <p>nuwave may process personal data relating to users if one of the following applies:</p>
        <ul>
          <li>Users have given their consent for one or more specific purposes.</li>
          <li>Provision of data is necessary for the performance of an agreement with the user.</li>
          <li>Processing is necessary for compliance with a legal obligation.</li>
          <li>
            Processing is necessary for the legitimate interests pursued by the controller or by a
            third party.
          </li>
        </ul>
        <p>
          In any case, nuwave will gladly help clarify the specific legal basis that applies to the
          processing, mainly whether the provision of personal data is a statutory or contractual
          requirement or a requirement necessary to enter into a contract.
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Consent for Use of Data in AI Modeling</Subtitle>
        <p>
          By using the nuLogic platform, you acknowledge and consent that we may use your anonymized
          responses and other collected data as inputs to develop and refine our artificial
          intelligence models. These models are designed to enhance our services and provide deeper
          insights into organizational culture. Please note:
        </p>
        <ul>
          <li>
            Input Only: Your data will be used strictly as inputs in the AI models. Outputs from the
            models will not contain or reflect any identifiable personal information.
          </li>
          <li>
            Purpose: The purpose of using data in this way is to improve the effectiveness of our
            tools and services in analyzing and enhancing workplace culture.
          </li>
          <li>
            Withdrawal of Consent: You have the right to withdraw your consent at any time. To do
            so, please contact us at info@nuwaveco.com. Withdrawal of consent will not affect the
            lawfulness of processing based on consent before its withdrawal.
          </li>
          <li>
            Safety and Confidentiality: We commit to maintaining the confidentiality and integrity
            of your data through the use of advanced security measures, consistent with industry
            standards and practices. Please contact us if you have any questions about the use of
            your data in our AI models.
          </li>
        </ul>
      </PageSection>
      <PageSection padbottom>
        <Subtitle>Security</Subtitle>
        <p>
          We take reasonable steps to protect your personal information using physical, electronic
          or procedural security measures appropriate to the sensitivity of the information in our
          custody or control, which may include safeguards to protect against loss or theft, as well
          as unauthorized access, disclosure, copying, use or modification. Authorized employees,
          agents and mandataries of nuwave who require access to your personal information in order
          to fulfil their job requirements will have access to your personal information.
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Retention Time</Subtitle>
        <p>
          Personal data is processed and stored for as long as required to fulfill the purpose for
          which it is collected.
        </p>
        <p>Therefore:</p>
        <ul>
          <li>
            Personal data collected for the performance of a contract between nuwave and a business
            customer is retained until such contract has been entirely performed or the business
            customer asks for the data to be deleted.
          </li>
          <li>
            Personal data collected for nuwave’s legitimate interests shall be retained as long as
            needed to fulfill such purposes. Users may find specific information regarding nuwave’s
            legitimate interests within the relevant sections of this document or by contacting
            nuwave.
          </li>
        </ul>
        <p>
          nuwave may be allowed to retain personal information for a more extended period whenever
          the user has given consent to such processing, as long as such consent is not withdrawn.
          Furthermore, nuwave may be obliged to retain personal data for a more extended period
          whenever required to perform a legal obligation or upon order of an authority.
        </p>
        <p>Once the retention period expires, the user’s personal data will be securely deleted.</p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>The Purposes of Processing</Subtitle>
        <p>
          The data concerning the user is collected to allow nuwave to provide its services, as well
          as for the following purposes: analytics, user database management, managing contacts and
          sending messages, handling payments, interaction with external social networks and
          platforms, remarketing and behavioral targeting, contacting the user, displaying content
          from external platforms, hosting and backend infrastructure, interaction with live chat
          platforms, and spam protection.
        </p>
        <p>
          Users can find further detailed information about such purposes of processing and the
          specific personal data used for each purpose in the respective sections of this document.
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Detailed Information on the Processing of Personal Data</Subtitle>
        <p>
          Personal data is collected for the following purposes and using the following services and
          third parties:
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Analytics</Subtitle>
        <p>
          The services contained in this section enable nuwave to monitor and analyze web traffic
          and can be used to keep track of user behavior.
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>HubSpot Analytics (HubSpot, Inc.)</Subtitle>
        <p>HubSpot Analytics is an analytics service provided by HubSpot, Inc.</p>
        <p>Personal data collected: cookies and usage data.</p>
        <p>Place of processing: US – For more information see the HubSpot Privacy Policy</p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Google Analytics (Google Inc.)</Subtitle>
        <p>
          Google Analytics is a web analysis service provided by Google Inc. (“Google”). Google
          utilizes the data collected to track and examine the use of this application, to prepare
          reports on its activities, and to share the reports with other Google services.
        </p>
        <p>
          Google may use the data collected to contextualize and personalize the ads of its own
          advertising network.
        </p>
        <p>Personal data collected: cookies and usage data.</p>
        <p>Place of processing: US – For more information see the Google Privacy Policy</p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Contacting the User</Subtitle>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Contact Form (The nuLogic Web Application)</Subtitle>
        <p>
          By filling in the contact form with their data, users authorize the nuLogic web
          application to use these details to reply to requests for information, quotes, or any
          other kind of request as indicated by the form’s headr.
        </p>
        <p>
          Personal data collected: address, city, company name, country, email address, first name,
          last name, phone number, job role, province, state, and ZIP/Postal code.
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Displaying Content from External Platforms</Subtitle>
        <p>
          This type of service allows users to view content hosted on external platforms directly
          from the pages of the nuLogic web application and interact with them.
        </p>
        <p>
          This type of service might still collect web traffic data for the pages where the service
          is installed, even when users do not use it.
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Google Fonts (Google Inc.)</Subtitle>
        <p>
          Google Fonts is a typeface visualization service provided by Google, Inc. that allows this
          Application to incorporate content of this kind on its pages.
        </p>
        <p>
          Personal data collected: usage data and various types of data as specified in the
          service’s privacy policy.
        </p>
        <p>Place of processing: US – For more information see the Google Privacy Policy.</p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Hosting and Back-End Infrastructure</Subtitle>
        <p>
          This type of service has the purpose of hosting data and files that enable the nuwave
          website and the nuLogic web application to run and be distributed. Additionally, these
          services provide the infrastructure to run specific features or parts of the application.
          Some of these services work through geographically distributed servers, making it
          difficult to determine the actual location where the personal data is stored.
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Amazon Web Services (AWS)</Subtitle>
        <p>Amazon Web Services (AWS) is a hosting and backend service provided by Amazon, Inc.</p>
        <p>
          Personal data collected: various types of data as specified in the privacy policy of the
          service.
        </p>
        <p>Place of processing: US – For more information see the Amazon Privacy Policy.</p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Postmark</Subtitle>
        <p>Postmark is an email delivery service.</p>
        <p>
          Personal data collected: various types of data as specified in the privacy policy of the
          service.
        </p>
        <p>Place of processing: US – For more information see the PostMark Privacy Policy.</p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Managing Contacts and Sending Messages</Subtitle>
        <p>
          This type of service makes it possible to manage a database of email contacts, phone
          contacts, or any other contact information to communicate with the user.
        </p>
        <p>
          These services may also collect data concerning the date and time when the message was
          viewed by the user and when the user interacted with it, such as by clicking on links
          included in the message.
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>HubSpot Email (HubSpot, Inc.)</Subtitle>
        <p>
          HubSpot Email is an email address management and message sending service provided by
          HubSpot, Inc.
        </p>
        <p>Personal data collected: email address and usage data.</p>
        <p>Place of processing: US – For more information see the HubSpot Privacy Policy.</p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Changes to This Privacy Notice</Subtitle>
        <p>
          nuwave reserves the right to make changes to this privacy notice at any time by giving
          notice to users on this page and possibly within this application or–as far as technically
          and legally feasible–sending a notice to users via any contact information available to
          nuwave. Users are strongly recommended to check this page often, referring to the date of
          the last modification listed at the bottom. Should the changes affect processing
          activities performed based on the users’ consent, nuwave shall collect new consent from
          the user where required.
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Further Information about Personal Data</Subtitle>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>The Rights of Users</Subtitle>

        <p>Users may exercise certain rights regarding their data processed by nuwave.</p>

        <p>In particular, users have the right to do the following:</p>
        <ul>
          <li>
            Withdraw their consent at any time. Users have the right to withdraw consent after they
            have previously given their consent to the processing of their personal data.
          </li>
          <li>
            Object to processing of their data. Users have the right to object to the processing of
            their data if the processing is carried out on a legal basis other than consent. Further
            details are provided in the dedicated section below.
          </li>
          <li>
            Access their data. Users have the right to learn if nuwave is processing their data,
            obtain disclosure regarding certain aspects of the processing, and obtain a copy of the
            data undergoing processing.
          </li>
          <li>
            Verify and seek rectification. Users have the right to verify their data accuracy and
            ask for it to be updated or corrected.
          </li>
          <li>
            Restrict the processing of their data. Users have the right, under certain
            circumstances, to restrict the processing of their daa. In this case, nuwave will not
            process their data for any purpose other tan storing it.
          </li>
          <li>
            Have their personal data deleted or otherwise removed. Users have the right, under
            certain circumstances, to obtain the erasure of their data from nuLoic.
          </li>
          <li>
            Receive their data and have it transferred to another controller. Users have the right
            to receive thei data in a structured, commonly used, machine-readable format, and, if
            technically feasible, to have it transmitted to another controller without any
            hindrance. This provision is applicable provided that the data is processed by automated
            means and that the processing is based on the user’s consent, on a contract that the
            user is part of, or on precontractual obligations.
          </li>
          <li>
            Lodge a complaint. Users have the right to bring a claim before their competent data
            protection authority.
          </li>
          <li>Details About the Right to Object to Procesing</li>
        </ul>
        <p>
          Where personal data is processed for the public interest, in the exercise of an official
          authority vested in nuwave or for the legitimate interests pursued by nuwave, users may
          object to such processing by providing a ground related to their particular situation to
          justify the objection.
        </p>
        <p>
          However, users must know that should their personal data be processed for direct marketing
          purposes, they can object to that processing at any time without providing any
          justification. To learn whether the nuwave is processing Personal Data for direct
          marketing purposes, users may refer to the relevant sections of this document.
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>How to Exercise These Rights</Subtitle>
        <p>
          Any requests to exercise user rights can be directed to nuwave through the contact details
          provided in this document (info@nuwaveco.com). These requests can be exercised free of
          charge and will be addressed by nuwave as early as possible and always within one month.
        </p>
        <p>Additional Information about Data Collection and Processing</p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Legal Action</Subtitle>
        <p>
          Users’ personal data may be used for legal purposes by nuwave in court or the stages
          leading to possible legal action arising from improper use of this application or the
          related services. The users declare they are aware that nuwave may be required to reveal
          personal data upon request of public authorities.
        </p>
        <p>Additional Information About Users’ Personal Data</p>
        <p>
          In addition to the information contained in this privacy notice, this application may
          provide users with additional and contextual information concerning particular services or
          the collection and processing of personal data upon request.
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>System Logs and Maintenance</Subtitle>
        <p>
          For operation and maintenance purposes, this application and any third-party services may
          collect files that record interaction with this application (e.g., system logs) using
          other personal data (e.g., IP Address) for this purpose.
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Information Not Contained in This Notice</Subtitle>
        <p>
          More details concerning the collection or processing of personal data may be requested
          from nuwave at any time. Users may use the contact information at the beginning of this
          document.
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>How “Do Not Track” Requests are Handled</Subtitle>
        <p>This application does not support “Do Not Track” requests.</p>
        <p>
          To determine whether any of the third-party services it uses honor “Do Not Track”
          requests, users should read their privacy policies.
        </p>
      </PageSection>

      <PageSection padbottom>
        <Title>Definitions and Legal References</Title>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Personal Data (or Data)</Subtitle>
        <p>
          Any information that directly, indirectly, or in connection with other
          information—including a personal identification number—allows for the identification or
          identifiability of a natural person.
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Usage Data</Subtitle>
        <p>
          Information collected automatically through this application (or obtained by services
          employed in this application)can include: the IP addresses or domain names of the
          computers utilized, the Uniform Resource Identifier (URI) addresses, the time of the
          request, the method used to submit the request to the server, the size of the file
          received in response, the numerical code indicating the status of the server’s answer
          (successful outcome, error, etc.), the country of origin, the features of the users’
          browser and operating system, the various time details per visit (e.g., the time spent on
          each page within the application), and the information on the path followed within the
          application with particular reference to the sequence of pages visited, and other
          parameters about the device operating system or the users’ IT environment.
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>User</Subtitle>
        <p>
          The individual using this application who, unless otherwise specified, coincides with the
          data subject.
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Data Subject</Subtitle>
        <p>The natural person to whom the personal data refers.</p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Data Processor</Subtitle>
        <p>
          The natural or legal person, public authority, agency, or other body that processes
          personal data on behalf of the controller, as described in this privacy notice.
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Sub-Processor</Subtitle>
        <p>
          This refers to any additional third party who processes personal data on behalf of the
          data processor in fulfilling contractual obligations and services.
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Data Controller</Subtitle>
        <p>
          The person, public authority, agency, or other body that determines the purposes and means
          of processing personal data, including the security measures concerning the operation and
          use of this application.
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>This Application</Subtitle>
        <p>
          The information technology system that collects and processes the personal data of the
          user.
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Service</Subtitle>
        <p>The service provided by the nuLogic platform or nuwave team.</p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>European Union (EU)</Subtitle>
        <p>
          Unless otherwise specified, all references made within this document to the European Union
          (EU) include all current member states to the European Union and the European Economic
          Area.
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Cookies</Subtitle>
        <p>Small piece of data stored on the user’s device.</p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Legal Information</Subtitle>
        <p>
          This privacy notice has been prepared based on provisions of multiple legislations,
          including Art. 13/14 of Regulation (EU) 2016/679 (General Data Protection Regulation).
        </p>
        <p>
          This privacy notice relates to the nuLogic website, application, and supporting services
          unless otherwise stated within this document.
        </p>
      </PageSection>
    </PageSection>
  </PageContent>
);

export default PrivacyPolicy;
